import { Star } from 'lucide-react';
import { Card } from '@/components/ui/card';

const testimonials = [
  {
    name: 'Sarah Johnson',
    role: 'Marketing Director',
    company: 'TechCorp Inc.',
    content: 'GiriChat has transformed how we communicate with our customers. The response rates are incredible - we\'ve seen a 300% increase in engagement!',
    rating: 5,
    avatar: 'SJ',
  },
  {
    name: 'Michael Chen',
    role: 'CEO',
    company: 'GrowthStart',
    content: 'The best investment we\'ve made this year. The automation features save us hours every day, and the ROI has been phenomenal.',
    rating: 5,
    avatar: 'MC',
  },
  {
    name: 'Emily Rodriguez',
    role: 'Sales Manager',
    company: 'SalesForce Pro',
    content: 'Our team loves how easy it is to use. We can now reach thousands of customers in minutes instead of hours. Game changer!',
    rating: 5,
    avatar: 'ER',
  },
  {
    name: 'David Kim',
    role: 'Business Owner',
    company: 'Local Retail',
    content: 'As a small business owner, GiriChat has leveled the playing field. I can now compete with bigger brands in customer communication.',
    rating: 5,
    avatar: 'DK',
  },
  {
    name: 'Jessica Martinez',
    role: 'Customer Success Lead',
    company: 'SaaS Solutions',
    content: 'The analytics dashboard is incredibly detailed. We can now make data-driven decisions and optimize our messaging strategy.',
    rating: 5,
    avatar: 'JM',
  },
  {
    name: 'Robert Taylor',
    role: 'Founder',
    company: 'E-commerce Plus',
    content: 'Support team is amazing! They helped us set everything up and we were sending campaigns within hours. Highly recommend!',
    rating: 5,
    avatar: 'RT',
  },
];

export function Testimonials() {
  return (
    <div className="bg-white py-12 sm:py-16 lg:py-20 px-4" id="testimonials" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            Loved by thousands of businesses
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            See what our customers have to say about GiriChat
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="p-4 sm:p-5 lg:p-6 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="flex gap-0.5 sm:gap-1 mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                "{testimonial.content}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#00D95F] flex items-center justify-center text-white font-semibold text-sm sm:text-base">
                  {testimonial.avatar}
                </div>
                <div>
                  <div className="text-sm sm:text-base text-gray-900 font-semibold">{testimonial.name}</div>
                  <div className="text-xs sm:text-sm text-gray-600">{testimonial.role}, {testimonial.company}</div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="mt-8 sm:mt-12 text-center">
          <div className="inline-flex items-center gap-2 bg-[#E8F9EE] px-4 sm:px-6 py-2 sm:py-3 rounded-full">
            <div className="flex -space-x-2">
              <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-[#00D95F] border-2 border-white"></div>
              <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-blue-500 border-2 border-white"></div>
              <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-purple-500 border-2 border-white"></div>
              <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-orange-500 border-2 border-white"></div>
            </div>
            <span className="text-xs sm:text-sm text-gray-700">Join 10,000+ happy customers</span>
          </div>
        </div>
      </div>
    </div>
  );
}
